<template>
  <div>
    <f7-row>
      <f7-col width="50">
        <DxDataGrid
          id="globalResults"
          :data-source="globalResults"
          :column-min-width="70"
          :column-auto-width="true"
          :allow-column-reordering="true"
          :show-borders="true"
          :show-column-lines="true"
          :show-row-lines="true"
          style="margin-top: 5px"
          :row-alternation-enabled="true"
          @exporting="onExportingGlobalResults"
        >
          <DxHeaderFilter :visible="true" />
          <DxStateStoring
            :enabled="true"
            type="localStorage"
            storage-key="globalResults"
          />
          <DxExport :enabled="true" />
          <DxPaging :page-size="10" />
          <DxSearchPanel :visible="false" />
          <DxColumn :caption="$t('resultCategory')">
            <DxColumn
              :data-field="'resultCategory'"
              :name="'resultCategory'"
              :caption="' '"
              :allow-header-filtering="false"
            />
            <DxColumn
              :data-field="'available'"
              :name="'available'"
              :caption="$t('available')"
              :allow-header-filtering="false"
            />
            <DxColumn
              :data-field="'total'"
              :name="'total'"
              :caption="$t('total')"
              :allow-header-filtering="false"
            />
          </DxColumn>
        </DxDataGrid>
        <DxDataGrid
          id="bestOptimization"
          :data-source="bestOptimizationFormated"
          :column-min-width="70"
          :column-auto-width="true"
          :allow-column-reordering="true"
          :show-borders="true"
          :show-column-lines="true"
          :show-row-lines="true"
          style="margin-top: 5px"
          :row-alternation-enabled="true"
          @exporting="onExportingBestOptimization"
        >
          <DxHeaderFilter :visible="true" />
          <DxStateStoring
            :enabled="true"
            type="localStorage"
            storage-key="bestOptimizationFormated"
          />
          <DxExport :enabled="true" />
          <DxPaging :page-size="10" />
          <DxSearchPanel :visible="false" />
          <DxColumn
            :caption="$t('DxOptimalCropDistributionAdvanced_Column_Caption')"
          >
            <DxColumn
              :data-field="'crop'"
              :name="'crop'"
              :caption="$t('Crop')"
              :allow-header-filtering="true"
            />
            <DxColumn
              :data-field="'surface'"
              :name="'surface'"
              :caption="$t('DxOptimalCropDistributionAdvanced_Column_surface')"
              :allow-header-filtering="false"
            />
            <DxColumn
              :data-field="'totalIrrigation'"
              :name="'totalIrrigation'"
              :caption="
                $t('DxOptimalCropDistributionAdvanced_Column_totalIrrigation')
              "
              :allow-header-filtering="false"
            />
            <DxColumn
              data-field="irrigationDose"
              name="irrigationDose"
              :caption="$t('DxOptimalCropDistributionAdvanced_Column_irrigationDose')"
              :allow-header-filtering="false"
              alignment="right"
              :calculate-display-value="calculateIrrigationDose"
            />
          </DxColumn>
        </DxDataGrid>
      </f7-col>
      <f7-col width="50">
        <DxOptimalCropDistributionPieChart :areas="areas" />
        <f7-row>
          <!-- <f7-col width="100" medium="50"></f7-col> -->
          <f7-col
            width="100"
            medium="100"
            class="resize-text"
          >
            {{ info }}
          </f7-col>
        </f7-row>
      </f7-col>
    </f7-row>
  </div>
</template>
<script>
import {
  DxDataGrid,
  DxPaging,
  DxSearchPanel,
  DxExport,
  DxColumn,
  DxStateStoring,
  DxHeaderFilter,
} from 'devextreme-vue/data-grid';
import DxOptimalCropDistributionPieChart from './DxOptimalCropDistributionPieChart.vue';

export default {
  name: 'DxOptimalCropDistribution',
  components: {
    DxDataGrid,
    DxPaging,
    DxSearchPanel,
    DxExport,
    DxColumn,
    DxStateStoring,
    DxHeaderFilter,
    DxOptimalCropDistributionPieChart,
  },
  props: {
    grossMargin: {
      type: Number,
      default: 0,
    },
    grossMarginDeviation: {
      type: Number,
      default: 0,
    },
    bestOptimization: {
      type: Object,
      default: () => {},
    },
    availableSurface: {
      type: Number,
      default: 0,
    },
    totalSurface: {
      type: Number,
      default: 0,
    },
    availableWater: {
      type: Number,
      default: 0,
    },
    irrigationWater: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      bestOptimizationFormated: {},
    };
  },
  computed: {
    areas() {
      const areas = [];
      for (const bestOptimization of this.bestOptimizationFormated) {
        areas.push({
          crop: bestOptimization.crop,
          area: this.getArea(this.availableSurface, bestOptimization.surface),
        });
      }
      return areas;
    },
    grossMarginMin() {
      return this.grossMargin - this.grossMarginDeviation;
    },
    grossMarginMax() {
      return this.grossMargin + this.grossMarginDeviation;
    },
    info() {
      return `${this.$t('expectedProfitability')}:
       ${this.$t('desde')} ${parseFloat(this.grossMarginMin).toFixed(2)}€
       ${this.$t('hasta')} ${parseFloat(this.grossMarginMax).toFixed(2)}€`;
    },
    globalResults() {
      return [
        {
          resultCategory: this.$t('irrigatedArea'),
          available: this.availableSurface,
          total: this.totalSurface,
        },
        {
          resultCategory: this.$t('irrigationWater'),
          available: this.availableWater,
          total: this.irrigationWater,
        },
        {
          resultCategory: this.$t('averageProfitability'),
          available: '---',
          total: this.grossMargin,
        },
      ];
    },
  },
  beforeMount() {
    this.setBestOptimizationFormated();
  },
  methods: {
    getArea(availableWater, totalIrrigation) {
      if (availableWater === 0) return 0;
      return parseFloat(totalIrrigation / availableWater).toFixed(3);
    },
    onExporting(e, tabName, fileName) {
      this.$helpers.onExporting(e, tabName, fileName);
    },
    onExportingGlobalResults(e) {
      this.onExporting(e, 'globalResults', 'globalResults.xlsx');
    },
    onExportingBestOptimization(e) {
      this.onExporting(e, 'bestOptimization', 'bestOptimization.xlsx');
    },
    setBestOptimizationFormated() {
      const bestOptimizationFormated = [];
      for (const crop in this.bestOptimization) {
        if (Object.hasOwnProperty.call(this.bestOptimization, crop)) {
          const cropData = this.bestOptimization[crop];
          let cropName = crop;
          if (cropName === 'fallow') {
            cropName = 'Barbecho';
          }
          bestOptimizationFormated.push({
            surface: cropData.surface,
            totalIrrigation: cropData.totalIrrigation,
            crop: cropName,
          });
        }
      }
      this.bestOptimizationFormated = bestOptimizationFormated;
    },
    calculateIrrigationDose(rowData) {
      if (rowData.surface) {
        return (rowData.totalIrrigation / rowData.surface).toFixed(2);
      }
      return 0;
    },
  },
};
</script>
<style scoped>
.resize-text {
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  padding: 20px;
}
</style>
